(function () {
  'use strict';

  /* @ngdoc object
   * @name seniorityList
   * @description
   *
   */
  angular
    .module('seniorityList', [
      'ui.router'
    ]);
}());
